import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Advisor } from './advisor';
import { AdvisorContext } from './advisor-context';

/**
 * Url in which the advisors live.
 */
const ADVISOR_HOST = 'https://advisors-static.ownup.com';

/**
 * Context provider for Advisor Data. When added to the DOM, all
 *   of its children will be able to use the {@link useAdvisor}
 *   and {@link useAdvisors} hook to access the advisor mapping.
 *
 * It does this by querying for the advisor dataset on load.
 *
 * @param props - No custom properties, just children.
 */
export const AdvisorProvider = (props: PropsWithChildren<{}>) => {
  const [advisors, setAdvisors] = useState<Record<string, Advisor>>({});

  useEffect(() => {
    const fetchAdvisors = async () => {
      try {
        const response = await fetch(`${ADVISOR_HOST}/index.json`);
        if (response.ok) {
          const data = (await response.json()) as Record<string, Advisor>;
          setAdvisors(data);
        } else {
          console.error('Failed to fetch advisors:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching advisors:', error);
      }
    };

    void fetchAdvisors();
  }, []);

  return <AdvisorContext.Provider value={advisors} {...props} />;
};
